// extracted by mini-css-extract-plugin
export default {"print":"print--OvIA8"};